// Local-calendar-date helpers. Event dates are stored as "YYYY-MM-DD" (or a
// timezone-less "YYYY-MM-DDTHH:mm:ss"). `new Date("2026-09-30")` parses as UTC
// midnight and displays as Sep 29 west of UTC — these helpers avoid that shift.

export const INACTIVE_EVENT_STATUSES = new Set(["cancelled", "completed"]);

export function parseLocalDate(value) {
  if (!value) return null;
  if (value instanceof Date) return value;
  const s = String(value);
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
  if (m) return new Date(+m[1], +m[2] - 1, +m[3]);
  return new Date(s);
}

export function toLocalIsoDate(d) {
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

export function formatEventDate(value, opts = { year: "numeric", month: "short", day: "numeric" }) {
  const d = parseLocalDate(value);
  return d && !Number.isNaN(d.getTime()) ? d.toLocaleDateString(undefined, opts) : "";
}

export function isPastLocalDate(value) {
  const d = parseLocalDate(value);
  if (!d) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return d < today;
}

export function isBookableEvent(e) {
  return !!e && !INACTIVE_EVENT_STATUSES.has(e.status) && !isPastLocalDate(e.date);
}
